module.exports = __webpack_public_path__ + "static/media/checkmark.284f3f03.svg";